import { adsActions, adsStore } from '#/store/ads/ads.store';

/* We re-use this function to handle ads on video play/pause events. */
export const handleAdPlayback = (shouldPlay: boolean) => {
  if (adsStore.isInsideAd) {
    if (adsStore.isAdPlaying && !shouldPlay) {
      adsActions.pause();

      return true;
    }

    adsActions.play();

    return true;
  }

  return false;
};
